import { API_URL } from '../config';

// Client HTTP minimal, sur le modèle de l'AuthInterceptor de sipconfection-frontend : pose le
// Bearer token sur chaque appel, et retente UNE fois après un refresh forcé sur un 401 (horloge
// de tablette en retard, ou refresh planifié pas encore passé).
//
// `getAccessToken`/`forcerRefresh` sont injectés par le composant appelant (issus de useAuth()) :
// ce module ne connaît pas React, il reste appelable depuis le gestionnaire de file hors-ligne.
let getAccessTokenRef = () => null;
let forcerRefreshRef = async () => null;

export function brancherAuth({ getAccessToken, forcerRefresh }) {
  getAccessTokenRef = getAccessToken;
  forcerRefreshRef = forcerRefresh;
}

/** Le backend renvoie `{"error": "..."}` sur ses refus métier (400/404) — même convention que
 * `signalerErreur` côté sipconfection-frontend : c'est CE texte qu'il faut remonter à l'écran. */
async function messageErreur(response, fallback) {
  try {
    const data = await response.clone().json();
    if (data?.error) return data.error;
  } catch {
    // corps non JSON (502 d'un proxy, etc.)
  }
  if (response.status === 403) return "Vous n'avez pas le droit d'effectuer cette action.";
  if (response.status === 401) return 'Session expirée. Reconnectez-vous.';
  if (response.status === 0) return 'Serveur injoignable.';
  return fallback || `Erreur serveur (HTTP ${response.status})`;
}

async function requete(path, options = {}, dejaRetente = false, tokenForce = null) {
  // `tokenForce` porte le jeton FRAÎCHEMENT obtenu par un refresh forcé (401 ci-dessous) : lire
  // `getAccessTokenRef()` à ce moment-là risquerait de retomber sur l'ancien jeton, le contexte
  // React n'ayant pas forcément fini de re-rendre et de rebrancher `brancherAuth()` entre les deux
  // appels — l'ancien jeton serait alors rejoué tel quel et échouerait à nouveau en 401.
  const token = tokenForce || getAccessTokenRef();
  const headers = { ...(options.headers || {}) };
  if (token) headers.Authorization = `Bearer ${token}`;
  if (options.body && !(options.body instanceof FormData) && !headers['Content-Type']) {
    headers['Content-Type'] = 'application/json';
  }

  let response;
  try {
    response = await fetch(API_URL + path, { ...options, headers });
  } catch (err) {
    const erreurReseau = new Error('Serveur injoignable — vérifiez la connexion.');
    erreurReseau.horsLigne = true;
    throw erreurReseau;
  }

  if (response.status === 401 && !dejaRetente) {
    const nouveauToken = await forcerRefreshRef();
    if (nouveauToken) return requete(path, options, true, nouveauToken);
  }

  if (!response.ok) {
    const err = new Error(await messageErreur(response));
    err.status = response.status;
    throw err;
  }

  if (response.status === 204) return null;
  const texte = await response.text();
  return texte ? JSON.parse(texte) : null;
}

export const http = {
  get: (path) => requete(path, { method: 'GET' }),
  post: (path, body) => requete(path, { method: 'POST', body: body != null ? JSON.stringify(body) : '{}' }),
  put: (path, body) => requete(path, { method: 'PUT', body: JSON.stringify(body) }),
  del: (path) => requete(path, { method: 'DELETE' }),
};
